import { render, staticRenderFns } from "./BrandLogin.vue?vue&type=template&id=23991119&scoped=true"
import script from "./BrandLogin.vue?vue&type=script&lang=js"
export * from "./BrandLogin.vue?vue&type=script&lang=js"
import style0 from "./BrandLogin.vue?vue&type=style&index=0&id=23991119&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23991119",
  null
  
)

export default component.exports